import { Component, Input, OnInit } from '@angular/core';

import { Subscription as AccountingSageSubscription } from '@data/models/accounting-sage.model';
import { AccountingSageService } from '@data/services/accounting-sage.service';

@Component({

    selector: 'syn-subscriptions',
    templateUrl: 'subscriptions.component.html',
})
export class SubscriptionsComponent implements OnInit {

    @Input() businessCode: string;

    public sageSubscriptions: AccountingSageSubscription[];
    public loading = true;

    constructor(private accountingSageService: AccountingSageService) {
    }

    async ngOnInit() {
        this.sageSubscriptions = await this.accountingSageService.findSubscriptions(this.businessCode).toPromise();
        this.loading = false;
    }
}
